module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', [_vm._v("Authenticated: " + _vm._s(_vm.authenticated))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.unlink($event)
      }
    }
  }, [_vm._v("unlink")])]), _vm._v(" "), _c('div', [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.register($event)
      }
    }
  }, [_vm._v("register")])]), _vm._v(" "), _c('div', [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.switchUser($event)
      }
    }
  }, [_vm._v("switch")])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', [_c('group', [_c('cell', {
    attrs: {
      "is-link": true,
      "link": _vm.attachmentLink,
      "border-intent": false
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "10px",
      "padding-top": "3px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/attachment.svg"),
      "width": "18px"
    }
  })]), _vm._v(_vm._s(_vm.attachmentLink))])]), _vm._v(" "), _c('cell', {
    attrs: {
      "is-link": true,
      "link": "http://apne2.s3.app.octomaster.com/hw/241/FjAIVsZtSB81xg2wSd6uMljGDCewkt3m_-_%E3%80%90%E7%B2%B5%E8%AA%9E%E8%A9%A9%E6%AD%8C%E3%80%91%E7%AB%99%E7%AB%8B%E6%95%AC%E7%95%8F%20I%20Stand%20in%20Awe-l7wRrN0TkiY.mp3?response-content-disposition=attachment%3B%20filename%3D%25E3%2580%2590%25E7%25B2%25B5%25E8%25AA%259E%25E8%25A9%25A9%25E6%25AD%258C%25E3%2580%2591%25E7%25AB%2599%25E7%25AB%258B%25E6%2595%25AC%25E7%2595%258F%2520I%2520Stand%2520in%2520Awe-l7wRrN0TkiY.mp3&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIASXMBQ2AAH2W7XPHF%2F20200323%2Fap-northeast-2%2Fs3%2Faws4_request&X-Amz-Date=20200323T211543Z&X-Amz-SignedHeaders=host&X-Amz-Expires=36000&X-Amz-Signature=b43dfdd36cf4f132f6f2591977759827ac0ccc96742ccf185d8ec7dd2c8eb600",
      "border-intent": false
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "10px",
      "padding-top": "3px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/attachment.svg"),
      "width": "18px"
    }
  })]), _vm._v("direct download")])])], 1)], 1), _vm._v(" "), _c('div', [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.logout($event)
      }
    }
  }, [_vm._v("logout")])]), _vm._v(" "), _c('div', [_c('a', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.resetLogger($event)
      }
    }
  }, [_vm._v("Reset Logger")])]), _vm._v(" "), _c('div', [_vm._v("\n   " + _vm._s(_vm.log) + "\n ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://open.weixin.qq.com/connect/oauth2/authorize?appid=ww62becac2e535d22e&redirect_uri=http%3A%2F%2Fm.octoedu.com%2Fauth%2Fassociate&response_type=code&scope=snsapi_base&state=#wechat_redirect"
    }
  }, [_vm._v("wechat auth")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("login")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "https://octomaster.com/m/students/me/scores/?course_instance=1422"
    }
  }, [_vm._v("scores link")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    attrs: {
      "href": "http://apne2.s3.app.octomaster.com/hw/241/FjAIVsZtSB81xg2wSd6uMljGDCewkt3m_-_%E3%80%90%E7%B2%B5%E8%AA%9E%E8%A9%A9%E6%AD%8C%E3%80%91%E7%AB%99%E7%AB%8B%E6%95%AC%E7%95%8F%20I%20Stand%20in%20Awe-l7wRrN0TkiY.mp3?response-content-disposition=attachment%3B%20filename%3D%25E3%2580%2590%25E7%25B2%25B5%25E8%25AA%259E%25E8%25A9%25A9%25E6%25AD%258C%25E3%2580%2591%25E7%25AB%2599%25E7%25AB%258B%25E6%2595%25AC%25E7%2595%258F%2520I%2520Stand%2520in%2520Awe-l7wRrN0TkiY.mp3&X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIASXMBQ2AAH2W7XPHF%2F20200323%2Fap-northeast-2%2Fs3%2Faws4_request&X-Amz-Date=20200323T211543Z&X-Amz-SignedHeaders=host&X-Amz-Expires=36000&X-Amz-Signature=b43dfdd36cf4f132f6f2591977759827ac0ccc96742ccf185d8ec7dd2c8eb600",
      "download": ""
    }
  }, [_vm._v("download")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b9e53fe"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Debug.vue
// module id = 554
// module chunks = 1